import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"

const endpoints = {
  validateToken: () => getUrlForEnv(services.PERMISSIONS_SERVICE, "/v2/validate-token"),
  setCredentials: () => "/api/v1/set-credentials",
  getCredentials: () => "/api/v1/get-credentials"
}

export default endpoints
